//export const API_ENDPOINT = "https://greenscan.brandgear.cz/_api/backoffice/";
export const isDev = () => {
  return process.env.NODE_ENV === "development";
}
const runtimeApiUrl = (typeof window !== 'undefined' && window.__ENV && window.__ENV.API_URL)
  ? window.__ENV.API_URL
  : undefined;

const envApiUrl = process.env.REACT_APP_API_URL;

const ENDPOINT = runtimeApiUrl || envApiUrl || (isDev() ? "http://gapi.test/api/" : "https://api.greenscan.cz/api/");

//export const API_ENDPOINT = process.env.API_ENDPOINT ? process.env.API_ENDPOINT : (isDev() ? "http://gapi.test/api/backoffice/" : "https://api.greenscan.cz/api/backoffice/");
//export const APP_ENDPOINT = process.env.APP_ENDPOINT ? process.env.APP_ENDPOINT : (isDev() ? "http://gapi.test/api/app/" : "https://api.greenscan.cz/api/app/");

//export const API_ENDPOINT = isDev() ? "http://gapi.test/api/backoffice/" : "https://api.greenscan.cz/api/backoffice/";
//export const APP_ENDPOINT = isDev() ? "http://gapi.test/api/app/" : "https://api.greenscan.cz/api/app/";
export const API_ENDPOINT = ENDPOINT + "backoffice/";
export const APP_ENDPOINT = ENDPOINT + "app/";

export const IMAGES_ENDPOINT = "https://greenscan.brandgear.cz/_api/images/";
export const GOOGLE_BUCKET = "https://storage.googleapis.com/greenscan/";
export const COLOR_BRAND = "#00a64f";
export const COLOR_INDICATOR1 = "#dddddd";
export const COLOR_INDICATOR2 = "#f540da";
export const COLOR_INDICATOR3 = "#3b71ed";
